const faqs = [
  {
    q: '棒棒TV是否需要注册或付费？',
    a: '完全不需要。棒棒TV是一款完全免费的在线影视平台，无需注册账号即可观看全部内容。我们不收取任何费用，也不设会员体系，所有资源对所有观众平等开放。',
  },
  {
    q: '为什么棒棒TV播放不卡顿？',
    a: '我们采用了智能CDN加速技术，在全国范围内部署了多个加速节点。同时平台支持多条播放线路自动切换，当某条线路出现波动时，系统会在毫秒级完成切换，确保播放始终流畅。',
  },
  {
    q: '棒棒TV支持哪些设备观看？',
    a: '棒棒TV完美适配手机、平板和电脑等主流设备。你只需通过浏览器访问即可，无需下载任何APP或插件。我们采用响应式设计，会自动根据你的屏幕尺寸优化显示效果。',
  },
  {
    q: '平台上的内容多久更新一次？',
    a: '我们保持每日同步更新的节奏。热播剧集通常在播出后短时间内即可上线，电影资源也会在院线下映后尽快安排。同时我们会根据用户反馈持续丰富内容库，确保资源多样性。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            常见问题
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-extrabold text-foreground-900">
            你可能想了解的问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            关于棒棒TV的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, idx) => (
            <details
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer"
              open={idx === 0}
            >
              <summary className="flex items-center justify-between p-5 md:p-6 list-none">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 text-left pr-4">
                  {faq.q}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-background-100 text-foreground-400 flex-shrink-0 group-open:bg-primary-100 group-open:text-primary-500 transition-all duration-200">
                  <i className="ri-arrow-down-s-line text-sm group-open:rotate-180 transition-transform duration-200"></i>
                </div>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6 -mt-2">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}